// Added by Sejune Oh on 2020-02-18
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    Input as MaterialInput,
    FilledInput as MaterialFilledInput,
    OutlinedInput as MaterialOutlinedInput,
    InputProps as MaterialStandardInputProps,
    FilledInputProps as MaterialFilledInputProps,
    OutlinedInputProps as MaterialOutlinedInputProps
} from '@material-ui/core'

// Common props
interface InputBaseProps { }

// Props for StandardInput
export type StandardInputBaseProps = Partial<MaterialStandardInputProps> & InputBaseProps;
export const StandardInput: FC<StandardInputBaseProps> = ({ ...props }) => {
    return <MaterialInput  {...props} />
}

// Props for FilledInput
export type FilledInputBaseProps = Partial<MaterialFilledInputProps> & InputBaseProps;
export const FilledInput: FC<FilledInputBaseProps> = ({ ...props }) => {
    return <MaterialFilledInput  {...props} />
}

// Props for OutlinedInput
export type OutlinedInputProps = Partial<MaterialOutlinedInputProps> & InputBaseProps;
export const OutlinedInput: FC<OutlinedInputProps> = ({ ...props }) => {
    return <MaterialOutlinedInput  {...props} labelWidth={0} />
}
